import { store } from '@/_store'
export const billingUtilsMixin = {
  methods: {
    checkPaymentMethodAndBudget: function () {
      if (store.state.authentication.toastNotificationData.dontChargePayments == 1) {
        return false;
      } else if ((store.state.authentication.toastNotificationData.hasDefaultPaymentMethod.length == 0 && store.state.authentication.toastNotificationData.trialPeriodData.trial_period_ended == 1) || (store.state.authentication.toastNotificationData.hasPendingPayments.length > 0)) {
        return true;
      }
      return false;      
    },

    hasPaymentMethodCC: function () {
      if (store.state.authentication.toastNotificationData.dontChargePayments == 1 || store.state.authentication.toastNotificationData.hasDefaultPaymentMethod.length > 0) {
        return true;
      }
      return false;
    },

    hasPaymentMethodCCReal: function () {
      if (store.state.authentication.toastNotificationData.hasDefaultPaymentMethod.length > 0) {
        return true;
      }
      return false;
    },

    hasPaymentMethodCCTrialPeriodEnded: function () {
      if (store.state.authentication.toastNotificationData.dontChargePayments == 1 || store.state.authentication.toastNotificationData.trialPeriodData.trial_period_ended == 0 || store.state.authentication.toastNotificationData.hasDefaultPaymentMethod.length > 0) {
        return true;
      }
      return false;
      
    },

    /**
     * Normalize charge-pendings API body (success or 402 reject payload).
     */
    normalizeChargePendingResult(result) {
      if (!result || typeof result !== 'object' || Array.isArray(result)) {
        return null;
      }
      if (!result.outcome) {
        return null;
      }
      return result;
    },

    /**
     * Resolve swal copy from charge-pendings structured response.
     * @param {object} result - API payload with outcome / error_code
     * @param {{ successInfoKey?: string }} options
     */
    getChargePendingSwalConfig(result, options = {}) {
      const successInfoKey =
        options.successInfoKey || 'lang.payment.successfulinfo';
      const outcome = result && result.outcome ? result.outcome : 'failed';

      let type = 'error';
      let title = this.$t('lang.payment.failed');
      let text = this.$t('lang.payment.failedinfo');

      if (outcome === 'success') {
        type = 'success';
        title = this.$t('lang.payment.successful');
        text = this.$t(successInfoKey);
      } else if (outcome === 'processing') {
        type = 'info';
        title = this.$t('lang.payment.processing');
        text = this.$t('lang.payment.processinginfo');
      } else if (outcome === 'partial') {
        type = 'warning';
        title = this.$t('lang.payment.partial');
        text = this.$t('lang.payment.partialinfo');
      } else {
        const errorCode = result && result.error_code ? String(result.error_code) : null;
        const codeKeys = errorCode
          ? [
              `lang.viva_payments.code_${errorCode}`,
              `lang.payment.code_${errorCode}`,
            ]
          : [];
        const matchedKey = codeKeys.find((key) => this.$te(key));
        if (matchedKey) {
          text = this.$t(matchedKey);
        }
      }

      return { type, title, text, outcome };
    },

    /**
     * Show swal for charge-pendings result. Returns the swal promise.
     */
    showChargePendingResultSwal(result, options = {}) {
      const normalized = this.normalizeChargePendingResult(result);
      const config = normalized
        ? this.getChargePendingSwalConfig(normalized, options)
        : {
            type: 'error',
            title: this.$t('lang.payment.error_debit'),
            text: this.$t('lang.payment.error_debit_detail'),
            outcome: 'failed',
          };

      return this.$swal({
        type: config.type,
        title: config.title,
        text: config.text,
        showConfirmButton: true,
      }).then((swalResult) => ({
        ...swalResult,
        outcome: config.outcome,
      }));
    },

  }
}
